import React from "react";

function ErrorLine(props) {
  return <p className="help is-danger errorLine">{props.children}</p>;
}
export default ErrorLine;
